import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { ApiService } from '../api.service'

@Component({
	selector: 'lesson-info',
	// standalone: true,
	// imports: [],
	templateUrl: './lesson-info.component.html',
	styleUrl: './lesson-info.component.scss'
})

export class LessonInfoComponent implements OnInit, OnChanges, OnDestroy {

	@Input() id = 0
	@Input() course = 0
	@Input() multitransl = false
	@Input() transl = 'es'

	name = ''
	headingsNum = 0
	activitiesNum = 0
	testsNum = 0
	
	getLessonInfoSub = new Subscription

	constructor(private dataService: ApiService) {}
	
	ngOnInit() {}

	ngOnChanges() {
		this.getLessonInfoSub = this.dataService.getLessonInfo(this.id)
		.subscribe({
			next: (lesson) => {
				console.log(lesson)
				this.name = lesson.name
				this.headingsNum = lesson.headings
			},
			error: (e) => {
				console.log(e)
			},
		})
	}

	ngOnDestroy() {
		this.getLessonInfoSub?.unsubscribe()
	}

}
